import './css/CatalogFrame.scss';
import { useCatSolr } from './hooks/useCatSolr';
import THLSkeleton from './common/THLSkeleton';
import React, { useEffect, useState } from 'react';
import './css/CatalogFrame.scss';
import { sortBibls } from './common/catalogUtils';
import { Redirect, useLocation } from 'react-router-dom';
import { NavSearch } from './search/NavSearch';
import { CollInfo } from './CollInfo';
import { Tabs, Tab } from 'react-bootstrap';
import CatalogSettings from './common/CatalogSettings';
import { useCatSearchStore } from './hooks/useCatSearchStore';
import { useBiblStore } from './hooks/useBiblStore';
import { getCatalogInfo } from './CatalogFrame';
import SplitPane, { Pane } from 'react-split-pane';
import { FrameContents } from './FrameContents';
import SearchResults from './search/SearchResults';
import TablesOfContents from './catnav/TablesOfContents';
import SearchFacets from './search/SearchFacets';
import $ from 'jquery';

export default function CatalogSummary() {
    const biblStore = useBiblStore();
    const [collsLoaded, setCollsLoaded] = useState(false);
    const [dragged, setDragged] = useState(false); // Drag state for split screen view
    // { path && (<Redirect path={path} />) }
    const [key, setKey] = useState('search'); // change back to 'search'
    const location = useLocation();
    const urlparams = new URLSearchParams(location?.search);
    let path = urlparams.get('path');

    const startDrag = () => {
        setDragged(true);
    };
    const endDrag = () => {
        setDragged(false);
        $('.Pane1 .l-frame-wrapper').width($('.Pane1').width());
        // console.log("pane 1 width: " + $('.Pane1').width(), $('.Pane1'));
    };

    // Queries SOLR for all collection and edition bibls and stores in BiblStore organized by collection for easier access and disambiguation of edition sigla
    useEffect(() => {
        // Add mdl-catalog class to body for scroll control of split frame
        document.body.classList.add('catframe');
        // Load Catalog info from search
        if (!biblStore?.collinfo) {
            const promise = getCatalogInfo();
            promise
                .then((resp) => {
                    // console.log('data in promise', resp);
                    if (resp?.data?.response?.docs?.length > 0) {
                        biblStore.setCollInfo(resp.data.response);
                    }
                })
                .finally(() => {
                    setCollsLoaded(true);
                });
        } else if (!collsLoaded) {
            // console.log('already bibstor coll info', bibStore.collinfo);
            setCollsLoaded(true);
        }
        return () => {
            // remove mdl-catalog class from body on unmount
            document.body.classList.remove('catframe');
        };
    }, []);

    if (path && path?.length > 0) {
        if (path.charAt(0) !== '/') {
            path = '/' + path;
        }
        path = (process.env.REACT_APP_BASE_PATH + path).replace(/\/\//g, '/');
        return <Redirect to={path} />;
    }

    return (
        /*
        <div className="l-catalog-wrapper front">
            <div className="summary">
                <div className="intro">
                    <h1>Catalog Overview</h1>
                    <p>The following catalogs are available:</p>
                </div>
                <div className="collections">
                    <CollList />
                </div>
            </div>
            <div className="summary-options">
                <Tabs
                    id="catsumopts"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                >
                    <Tab eventKey="search" title="Search">
                        <div className="search-form">
                            <NavSearch />
                        </div>
                    </Tab>
                    <Tab eventKey="settings" title="Settings">
                        <CatalogSettings />
                    </Tab>
                </Tabs>
            </div>
        </div>*/
        <SplitPane
            split="vertical"
            primary="second"
            className="l-catalog-frame l-catalog-wrapper front px-3"
            defaultSize="25vw"
            allowResize={true}
            onDragStarted={startDrag}
            onDragFinished={endDrag}
        >
            <Pane id="catalog-sp-1" className="l-frame-content">
                <div className="l-frame-wrapper">
                    <div className="summary">
                        <div className="intro">
                            <h1>Catalog Overview</h1>
                            <p>The following catalogs are available:</p>
                        </div>
                        <div className="collections">
                            <CollList />
                        </div>
                    </div>
                </div>
            </Pane>
            <Pane id="catalog-sp-2" className="l-frame-toc">
                <div className="l-frame-wrapper" id="catalog-sp-wrapper">
                    <div className="summary-options">
                        <Tabs
                            id="catsumopts"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="search" title="Search">
                                <div className="search-form">
                                    <NavSearch />
                                </div>
                            </Tab>
                            <Tab eventKey="settings" title="Settings">
                                <CatalogSettings />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </Pane>
        </SplitPane>
    );
}

function CollList() {
    const query = {
        q: 'subtype:(collection OR edition)',
        fq: 'type:tibbibl',
        fl: '*',
        rows: 200,
    };
    let {
        isLoading: isCollInfoLoading,
        data: collInfo,
        isError: isCollInfoError,
        error: collInfoError,
    } = useCatSolr(query);

    if (isCollInfoLoading) {
        return <THLSkeleton />;
    }

    if (isCollInfoError) {
        return (
            <p>
                <strong>Notice:</strong> Unable to contact the SOLR index (
                {collInfoError?.message}).
            </p>
        );
    }

    if (!collInfo?.docs || collInfo.docs.length === 0) {
        return (
            <p>
                No collections found in the SOLR index. Please talk to your
                administrator.
            </p>
        );
    }
    // console.log('coll info in collsummary', collInfo);
    collInfo = sortBibls(collInfo.docs, 'title_en');

    return (
        <>
            {collInfo
                ?.filter((ci) => ci.subtype === 'collection')
                .map((d, i) => {
                    return (
                        <CollInfo
                            key={`coll-list-item-${i}`}
                            doc={d}
                            eds={collInfo.filter(
                                (ci) =>
                                    ci.subtype === 'edition' &&
                                    ci.coll === d?.coll
                            )}
                        />
                    );
                })}
        </>
    );
}
